<template lang="pug">
  div
    form.w-full.max-w-2xl.mt-6(v-on:submit="sendRequest")
      .flex.flex-wrap.-mx-3
        .w-full.px-3(class='md:w-2/3 md:mb-0')
          label(for='address') IP Address
          input#address(placeholder='0.0.0.0' type="text" v-model="address")
        .w-full.px-3(class='md:w-1/3 md:mb-0')
          label(for='trace') Trace
          CustomSelect(:options="[['Full Trace', true], ['Krystal DNS Cache', false]]" v-model="trace" id="trace")
      input.button.mt-3(type="submit" v-bind:disabled="loading" v-bind:class="{ 'opacity-50': loading }" value="Send")
    div.text-gray-100.font-mono.bg-black.rounded.p-4.mt-6(v-if="response || hasError")
      div.text-red-400(v-if="hasError") {{errorMessage}}
      div(v-else v-for="result in response")
        div.text-gray-500 {{result.server}}
        div.ml-4(v-for="answer in result.answers") {{answer.type}}: {{answer.name}}, {{answer.value}} (TTL: {{answer.ttl}})
</template>
<script>
import CustomSelect from "@/components/CustomSelect";
import common_computed from "@/mixins/common_computed";
import errors from "@/mixins/errors";

export default {
  mixins: [common_computed, errors],
  components: {
    CustomSelect: CustomSelect,
  },
  data() {
    return {
      address: "",
      trace: true,
      response: null,
    };
  },
  computed: {
    searchParams() {
      return new URLSearchParams({
        ip_address: this.address,
        trace: this.trace,
      });
    },
  },
  methods: {
    sendRequest(e) {
      e.preventDefault();
      this.clearError();
      this.loading = true;
      fetch(`${this.selectedHost}/v1/dns/reverse?${this.searchParams}`, {
        method: "GET",
      })
        .then((resp) => {
          this.loading = false;
          if (!resp.ok) {
            this.hasError = true;
          }
          return resp.json();
        })
        .then((json) => {
          if (this.hasError) {
            this.setError(json.error.description);
          } else {
            this.response = json.results;
          }
        })
        .catch((error) => {
          console.error(error);
          this.setError("Unable to lookup reverse DNS, an error occurred");
        });
    },
  },
};
</script>
